<template>
  <div class="form-group">
    <label :for="fieldId">{{ label }}</label>
    <hilo-button label="Upload File" @click="() => $refs.fileInput.click()" />
    <input
      type="file"
      :id="fieldId"
      ref="fileInput"
      @change="handleFileUpload"
      style="display: none;"
    />
    <span v-if="fileName" class="file-name">{{ fileName }}</span>
    <span v-if="isRequired && !value && !fileName" class="error-message">Required</span>
    <span v-else-if="value || fileName" class="success-message">✔</span>
  </div>
</template>

<script>
import HiloButton from './HiloButton.vue';

export default {
  components: {HiloButton},
  props: {
    label: {
      type: String,
      required: true,
    },
    fieldId: {
      type: String,
      required: true,
    },
    value: {
      type: [File, String],
      default: null,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    showFileName: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      fileName: this.getInitialFileName(),
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.fileName = file ? file.name : '';
      this.$emit('input', file);
      this.$emit('upload-success', file);
    },
    getInitialFileName() {
      if (this.value instanceof File && this.showFileName) {
        return this.value.name;
      }
      return '';
    },
  },
  watch: {
    value() {
      this.fileName = this.getInitialFileName();
    }
  }
};
</script>

<style>
.file-name, .error-message, .success-message {
  margin-left: 10px;
  font-size: 16px;
}

.file-name {
  color: #333;
}

.error-message {
  color: red;
}

.success-message {
  color: green;
}
</style>
